import React from 'react';

import { InsuranceCardMain } from './insurance-card-main';
import styles from './walleted-insurance.module.less';
import DataDrivenLogo from '../../../../components/data-driven-logo';

/**
 * @param {object} props
 * @param {boolean} props.isInsuranceActivated
 * @param {string} props.insuranceProviderId
 * @returns {React.ReactElement}
 */
export const InsuranceCard = ({ isInsuranceActivated, insuranceProviderId }) => {
  return (
    <div className={styles['insurance-card']}>
      <div className={styles['insurance-logo']}>
        <DataDrivenLogo insuranceProviderId={insuranceProviderId} />
      </div>
      <InsuranceCardMain insuranceProviderId={insuranceProviderId} isInsuranceActivated={isInsuranceActivated} />
    </div>
  );
};
